import {AppLocale} from '@config/locales';
import {useMeQuery} from '@hooks/useMeQuery';
import {formatInTimeZone} from 'date-fns-tz';
import {de, enUS} from 'date-fns/locale';
import {useLocale} from 'next-intl';

export const useFormattedDate = (
    date: string | number | Date,
    template = 'P',
) => {
    const locale = useLocale();
    const {
        query: {data: user},
    } = useMeQuery();
    const dateLocales = {[AppLocale.EN]: enUS, [AppLocale.DE]: de}[locale];
    const timeZone = user?.timezone ?? 'Europe/Berlin';

    return formatInTimeZone(date, timeZone, template, {
        locale: dateLocales,
    });
};
